import { developmentMode } from '/shared/util/Statics';

import Footer from '/business/shared/components/widgets/footer/Footer';
import DebugFooter from '/business/shared/components/debug/DebugFooter';

import StyledMiscLayoutFooter from './__styled__/StyledMiscLayoutFooter';

function MiscLayoutFooter({ $isFixedToBottom = false }) {
  return (
    <StyledMiscLayoutFooter $isFixedToBottom={$isFixedToBottom}>
      <Footer />
      {developmentMode && <DebugFooter />}
    </StyledMiscLayoutFooter>
  );
}

export default MiscLayoutFooter;
